export const GET_TRANSFER_INSTRUCTIONS_REQUEST = 'GET_TRANSFER_INSTRUCTIONS_REQUEST';
export const GET_TRANSFER_INSTRUCTIONS_SUCCESS = 'GET_TRANSFER_INSTRUCTIONS_SUCCESS';
export const GET_TRANSFER_INSTRUCTIONS_ERROR = 'GET_TRANSFER_INSTRUCTIONS_ERROR';

export function getTransferInstructions() {
  return {
    types: [GET_TRANSFER_INSTRUCTIONS_REQUEST, GET_TRANSFER_INSTRUCTIONS_SUCCESS, GET_TRANSFER_INSTRUCTIONS_ERROR],
    fetch: { url: `/api/v2/instructions/tseu-sepa-deposit` },
  };
}
